import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import resultComp from '../comps/resultComp.vue';
import * as shareApi from '../api/shareApi';
import downloadApp from '@ivy/fts/inner/topBarOpenApp.vue';
let default_1 = class extends Vue {
    constructor() {
        super(...arguments);
        this.showResult = false;
        this.current = {};
        this.last = {};
    }
    async mounted() {
        await env.init();
        let { test_id } = this.$route.query;
        // 有test_id展示分享人测评结果页
        if (test_id) {
            env.type === 'wx' && (await shareApi.share(test_id));
            let { data } = await shareApi.requireGet('/api/m-course/lexile/getResultByTestId', {
                test_id,
            });
            this.current = data.current;
            this.last = data.last_time;
            this.babyUrl = data.user_info.avatar;
            this.babyName = data.user_info.nickname;
            if (data.last_time) {
                // 蓝思阶段测评报告分享落地页的访问埋点
                await shareApi.getUpload('Display_ProgressMonitoringTest_Lexile');
            }
            else {
                // 蓝思定位测评报告分享落地页的访问埋点
                await shareApi.getUpload('Display_PlacementTest_Lexile');
            }
            this.showResult = true;
        }
        else {
            this.showResult = true;
        }
    }
};
default_1 = tslib_1.__decorate([
    Component({
        components: {
            resultComp,
            downloadApp,
        },
    })
], default_1);
export default default_1;
